
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/d/artist/[artistSlug]/albums",
      function () {
        return require("private-next-pages/d/artist/[artistSlug]/albums.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/d/artist/[artistSlug]/albums"])
      });
    }
  